// @ts-nocheck
import _ from 'lodash';
import * as dynamicGridSagaActions from 'models/dynamicGrid/sagaActions';
import exportFromJSON from 'export-from-json';
import moment from 'moment';
import { put, select, takeLatest } from 'redux-saga/effects';
import {
	checkPollingStatus,
	checkPollingStatusV2,
	deleteAPIDataV2,
	getAPIDataV2,
	getAPIDataV3,
	postAPIData,
	postAPIDataV3,
	putAPIData,
	putAPIDataV2,
	putAPIDataV3,
} from 'utils/api';
import * as slice from './reducer';
import * as sagaActions from './sagaActions';
import * as tableColumnsSagaActions from 'models/tableColumns/sagaActions';
import { createFiltersFromQueries } from 'models/dynamicGrid/query';
import { triggerNotification } from 'organisms/notifications/sagaActions';
import * as dynamicGridSelectors from 'models/dynamicGrid/selector';
import { DISTRIBUTE_SKUS_TABLE_ID, SELECT_SKUS_TABLE_ID } from './thetaDistributeExcessAvailability/constants';
import { SELECT_STORES_TABLE_ID } from './thetaOrderCloneModal/constants';
import { generateFileFromString, objectToXML } from './utils';
import { onPublishEvent, onReceiveEvent } from 'models/subscriptions/sagaActions';
import { Events } from 'molecules/ReactGrid/agGrid/utils/events';
import { GRID_EVENTS } from 'molecules/ReactGrid/agGrid/constants';
import { getDispatch, getState } from 'reducers';
import { toggleLoader } from 'models/loaders/sagaActions';
import { getOptimizeShipMethodNumber } from './selectors';
import { updateMultiRows } from 'models/dynamicGrid/reducer';
import { getDistributeAvailabilityNumber } from './thetaDistributeExcessAvailability/selectors';
import { REQUESTS } from 'utils/services/thetaretail/requests';
import { getWebAppSettings } from 'models/user/selector';
import FileDownload from 'react-file-download';
import { getGridMetadata } from 'models/dynamicGrid/selector';

const lockUnlockRecord = async (tableId: any, data: any) => {
	const isView = getWebAppSettings(getState())?.IsAclRowLevelAccessEnabled;

	return putAPIDataV3({
		...REQUESTS.PUT.TOGGLE_ORDER_STATE,
		body: { ...data, AppTableID: Number(tableId), isView },
	}).catch((error) => ({
		isError: true,
		error,
	}));
};

export default function* rootSaga() {
	function* updateSkuQty(orderSkuId, orderQty) {}

	function* updateRowData({ payload }) {
		let { tableId, row, rowIdentifier, updatedValue, BulkUpdateJSON } = payload;
		const ordersFilter = dynamicGridSelectors.getGridFilters(getState(), tableId);

		if (
			tableId !== 30 &&
			(ordersFilter?.groupKeys?.length ||
				ordersFilter?.pivotColumns?.length ||
				ordersFilter?.rowGroupCols?.length)
		) {
			return;
		}
		if (tableId === 36) {
			try {
				if (updatedValue < 0) {
					throw new Error('Value should be greater than or equal to 0');
				}
				if (updatedValue % row.OrderMultiple !== 0) {
					throw new Error('Value should be a multiple of ' + row.OrderMultiple);
				}
				const { data, isError, error } = yield putAPIDataV3({
					...REQUESTS.PUT.UPDATE_DISTRIBUTE_SKUS,
					body: {
						updatedAvailability: [{ ColumnName: rowIdentifier, ColumnValue: updatedValue }],
						distNumber: getDistributeAvailabilityNumber(getState()),
					},
					pathParams: {
						distributeRowId: row.DistAvailListID,
					},
				})
					.then()
					.catch((e) => ({ isError: true, error: e }));
				if (error) {
					throw new Error(error.message);
				}
				yield put(dynamicGridSagaActions.updateTableCell(payload));
			} catch (error) {
				payload.updatedValue = {
					value: payload.updatedValue,
					hasError: true,
					errorMessage: error?.message || error?.data?.message,
				};

				yield put(dynamicGridSagaActions.updateTableCell(payload));
				yield put(
					triggerNotification({
						message: error?.message || error?.data?.message,
					})
				);
			}
		}

		if (tableId === 1) {
			try {
				if (updatedValue < 0) {
					throw new Error('Value should be greater than or equal to 0');
				}
				if (!BulkUpdateJSON && updatedValue % row.OrderMultiple !== 0 && row.OrderMultiple) {
					throw new Error('Value should be a multiple of ' + row.OrderMultiple);
				}

				// const { isError, error } = yield putAPIDataV2('orders', `skuqty/${row.OrderDetailID}`, {
				// 	BulkLoad: 0,
				// 	OrderQty_New: updatedValue,
				// 	SKUID: row.OrderDetailID
				// }).catch(e => {
				// 	return { isError: true, error: e };
				// });

				// if (isError) {
				// 	throw error || 'Something went wrong';
				// }
				// yield put(dynamicGridSagaActions.updateTableCell(payload));
				// yield handleFetchOrderInfo({ payload: { tableId: tableId } });
				return;
			} catch (error) {
				payload.updatedValue = {
					value: payload.updatedValue,
					hasError: true,
					errorMessage: error?.message || error?.data?.message,
				};
				yield put(dynamicGridSagaActions.updateTableCell(payload));
				// yield put(
				// 	triggerNotification({
				// 		message: error?.message || error?.data?.message
				// 	})
				// );
				return;
			}
		}
		if (tableId === 2 || tableId === 3 || tableId === 4 || tableId === 5 || tableId === 6) {
			try {
				if (updatedValue < 0) {
					throw new Error('Value should be greater than or equal to 0');
				}
				if (!BulkUpdateJSON && updatedValue % row.QtyPerShelf !== 0 && row.QtyPerShelf) {
					throw new Error('Value should be a multiple of ' + row.QtyPerShelf);
				}

				yield put(slice.updateInfoTimestamp({ refreshInfoTimestamp: Date.now() }));
			} catch (error) {
				payload.updatedValue = {
					value: payload.updatedValue,
					hasError: true,
					errorMessage: error?.message || error?.data?.message,
				};

				yield put(dynamicGridSagaActions.updateTableCell(payload));
				yield put(
					triggerNotification({
						message: error?.message || error?.data?.message,
					})
				);
			}
		}
		if (tableId === 35) {
			try {
				const getUpdatedParams = () => {
					switch (rowIdentifier) {
						case 'ShipDate':
							return {
								newShipDate: updatedValue,
								OrderID: row.OrderID,
							};
						case 'PODate':
							return {
								newPODate: updatedValue,
								OrderID: row.OrderID,
							};
						default:
							return {
								NewOrderShipMethodQty: updatedValue,
								OrderID: row.OrderID,
							};
					}
				};
				yield putAPIDataV3({
					...REQUESTS.PUT.UPDATE_ORDER_SPLIT_PARAMS,
					pathParams: { OrderSplitID: row.OrderSplitID },
					body: getUpdatedParams(),
				});
				yield put(dynamicGridSagaActions.updateTableCell(payload));
			} catch (error) {
				payload.updatedValue = {
					value: payload.updatedValue,
					hasError: true,
					errorMessage: error?.message || error?.data?.message,
				};

				yield put(dynamicGridSagaActions.updateTableCell(payload));
				yield put(
					triggerNotification({
						message: error?.message || error?.data?.message,
					})
				);
			}
		}
		if (tableId === 30) {
			try {
				if (updatedValue % row.OrderMultiple !== 0) {
					throw new Error('Value should be a multiple of ' + row.OrderMultiple);
				}
				if (updatedValue < 0) {
					throw new Error('Value should be greater than or equal to 0');
				}
				const metaData = yield select((state) => dynamicGridSelectors.getGridMetadata(state, tableId));

				const { data, isError, error } = yield putAPIDataV3({
					...REQUESTS.PUT.PUT_ORDER_KITS,
					pathParams: { orderKitId: row.OrderKitID },
					body: {
						orderQtyNew: updatedValue,
						orderKitId: row.OrderKitID,
					},
				})
					.then()
					.catch((e) => ({ isError: true, error: e }));

				if (isError) {
					throw error || 'Something went wrong';
				}

				// Avoid mutating the (frozen) payload object; create a new payload
				const cellPayload = {
					...payload,
					[rowIdentifier]: payload.updatedValue,
				};
				yield put(dynamicGridSagaActions.updateTableCell(cellPayload));
				Events.publish(GRID_EVENTS.PURGE_GRID_ROUTE, {
					tableId,
					route: [row.OrderKitID],
				});

				// yield put(dynamicGridSagaActions.updateTableCell(payload));

				yield put(
					dynamicGridSagaActions.handleRowUpdateSuccess({
						tableId,
						row,
						rowIdentifier,
					})
				);
				// yield put(dynamicGridSagaActions.fetchGridData(tableId));
			} catch (error) {
				payload.updatedValue = {
					value: payload.updatedValue,
					hasError: true,
					errorMessage: error?.message || error?.data?.message,
				};

				yield put(dynamicGridSagaActions.updateTableCell(payload));
			}
		}
		if (tableId === 37) {
			try {
				const { response, isError, error } = yield putAPIDataV3({
					...REQUESTS.PUT.UPDATE_OPTIMIZE_DESIRED_QTY,
					pathParams: { orderId: row.OrderID },
					body: {
						desiredQty: updatedValue,
						optimizeShipMethodNumber: getOptimizeShipMethodNumber(getState()),
					},
				})
					.then()
					.catch((e) => ({ isError: true, error: e }));
				if (updatedValue < 0) {
					throw new Error('Value should be a greater than 0');
				}
				if (isError) {
					throw error || 'Something went wrong';
				}
				console.log(payload);
				yield put(dynamicGridSagaActions.updateTableCell(payload));
				// yield put(dynamicGridSagaActions.fetchGridData(tableId));
			} catch (error) {
				payload.updatedValue = {
					value: payload.updatedValue,
					hasError: true,
					errorMessage: error?.message || error?.data?.message,
				};
				yield put(dynamicGridSagaActions.updateTableCell(payload));
				yield put(
					triggerNotification({
						message: error?.message || error?.data?.message,
					})
				);
			}
		}
	}

	//clone
	function* handleUpdateCloneSelectedParameters({ payload }) {
		const { selectedParameters } = payload;

		yield put(slice.updateCloneSelectedParameters({ selectedParameters }));
	}
	function* handleGetCloneDefaultColumnTypes() {
		const defaultColumns = yield getAPIDataV3({
			service: REQUESTS.GET.GET_ORDER_CLONE_TYPES.service,
			url: REQUESTS.GET.GET_ORDER_CLONE_TYPES.url,
			pathParams: { cloneLookupType: 1 },
		})
			.then((response) => response?.data.data)
			.catch((error) => ({ isError: true, error }));

		if (defaultColumns?.isError) {
			yield put(
				triggerNotification({
					message: 'An error occurred while fetching clone types, please try again later',
				})
			);
			return;
		}
		yield put(slice.updateCloneDefaultColumnTypes({ defaultColumns }));
	}
	function* handleCloneOrders({ payload }) {
		const { data, tableId } = payload;
		yield handleToggleLoading({ payload: { status: true } });
		const ordersSearch = yield select((state) => dynamicGridSelectors.getGridFilters(state, tableId));
		const selectedOrders = yield select((state) => dynamicGridSelectors.getTableSelection(state, tableId));
		const storeSearch = yield select((state) => dynamicGridSelectors.getGridFilters(state, SELECT_STORES_TABLE_ID));
		const selectedStores = yield select((state) =>
			dynamicGridSelectors.getTableSelection(state, SELECT_STORES_TABLE_ID)
		);
		const gridData = dynamicGridSelectors.getGridData(getState(), tableId);

		const selectedCustomerIds = _.uniq(
			_.map(
				_.filter(gridData, (r) => _.includes(selectedOrders?.selectedRowKeys, r.OrderID)),
				(c) => c.CustomerNum
			)
		);
		const isView = getWebAppSettings(getState())?.IsAclRowLevelAccessEnabled;

		let payloadData = {
			...data,
			ordersSearch: JSON.stringify({
				filter: createFiltersFromQueries(ordersSearch.search),
			}),
			isSelectAllOrders: selectedOrders.isSelectAll,
			selectedCustomerIds,
			orderIds: selectedOrders?.selectedRowKeys.join(','),
			tableId: Number(tableId),
			isView,
		};

		if (payloadData?.storeIds) {
			payloadData = {
				...payloadData,
				storeSearch: JSON.stringify({
					filter: createFiltersFromQueries(storeSearch.search),
				}),
				storeIds: selectedStores?.selectedRowKeys.join(','),
				isSelectAllStore: selectedStores.isSelectAll,
			};
		}

		const { isError } = yield postAPIDataV3({ ...REQUESTS.POST.POST_ORDER_CLONE, body: payloadData })
			.then((response) => response?.data)
			.catch((error) => ({ isError: true, error }));
		if (isError) {
			yield put(
				triggerNotification({
					message: 'An error occurred while cloning order, please try again later',
				})
			);
			yield handleToggleLoading({ payload: { status: false } });
			return;
		}
	}

	//split
	function* handleUpdateSplitSelectedParameters({ payload }) {
		const { selectedParameters } = payload;
		yield put(slice.updateSplitSelectedParameters({ selectedParameters }));
	}

	function* handleGetSplitDefaultColumnTypes() {
		try {
			// Fetch default column types
			const response = yield getAPIDataV3({
				service: REQUESTS.GET.GET_ORDER_CLONE_TYPES.service,
				url: REQUESTS.GET.GET_ORDER_CLONE_TYPES.url,
				pathParams: { cloneLookupType: 2 },
			});

			// Check if API call failed
			if (!response || response?.isError) {
				throw new Error(response?.error?.message || 'An error occurred while fetching default column types.');
			}

			// Extract data safely
			const defaultColumns = response?.data?.data || [];

			// Dispatch action to update store
			yield put(slice.updateSplitDefaultColumnTypes({ defaultColumns }));
		} catch (error) {
			console.error('Saga Error in handleGetSplitDefaultColumnTypes:', error);
			yield put(
				triggerNotification({
					message: error?.message || 'An error occurred while updating state, please try again later.',
				})
			);
		}
	}

	function* handleSplitOrders({ payload }) {
		try {
			const { data, tableId } = payload;
			yield handleToggleLoading({ payload: { status: true } });

			// Get `isView` safely using `yield select()`
			const isView = yield select((state) => getWebAppSettings(state)?.IsAclRowLevelAccessEnabled);

			// Call API with error handling
			const response = yield postAPIDataV3({
				...REQUESTS.POST.SPLIT_ORDERS,
				body: { ...data, tableId, isView },
			}).catch((error) => {
				console.error('Error in SPLIT_ORDERS API:', error);
				return { isError: true, error };
			});

			// Check for errors
			if (response?.isError) {
				const errorMessage =
					response?.error?.message || 'An error occurred while updating state, please try again later';
				yield put(triggerNotification({ message: errorMessage }));
				return;
			}
		} catch (error) {
			yield put(
				triggerNotification({
					message: error?.message || 'An unexpected error occurred while processing the request',
				})
			);
		}
	}

	//lock-unlock records
	function* lockUnlockRecords({ payload }) {
		try {
			const { data, tableId } = payload;

			// Get order search filters
			const ordersSearch = yield select((state) => dynamicGridSelectors.getGridFilters(state, tableId));

			// Call API with error handling
			const response = yield lockUnlockRecord(tableId, {
				...data,
				selectAllSearch: JSON.stringify({
					filter: createFiltersFromQueries(ordersSearch?.search || []),
				}),
			}).catch((error) => {
				console.error('Error in lockUnlockRecord API:', error);
				return { isError: true, error };
			});

			// Handle API errors
			if (response?.isError) {
				const errorMessage =
					response?.error?.message || 'An error occurred while updating state, please try again later';
				yield put(triggerNotification({ message: errorMessage }));
				return;
			}

			// Handle warnings from API response
			if (response?.data?.isWarning) {
				yield put(triggerNotification({ message: response?.data.message, type: 'warning' }));
				return;
			}

			// Get grid rows and metadata
			let gridRows = yield select((state) => dynamicGridSelectors.getGridData(state, tableId));
			const selectRowKey = yield select(
				(state) => dynamicGridSelectors.getGridMetadata(state, tableId)?.selectRowKey
			);

			// Ensure OrderIDs exist
			const orderIds = data?.OrderIDs ? data.OrderIDs.split(',').map((o) => Number(o)) : [];

			// Filter and update grid rows
			gridRows = _.map(
				_.filter(gridRows, (r) => orderIds.includes(r[selectRowKey])),
				(d) => ({ ...d, IsReadOnly: data.IsReadOnly })
			);

			yield put(
				triggerNotification({
					message: 'Data updated successfully',
					type: 'success',
				})
			);

			// Publish grid update event
			Events.publish(GRID_EVENTS.UPDATE_GRID, { tableId, updatedRows: gridRows });
			Events.publish(GRID_EVENTS.CLEAR_SELECTION, { tableId });
		} catch (error) {
			console.error('Saga Error in lockUnlockRecords:', error);
			yield put(
				triggerNotification({
					message: error?.message || 'An unexpected error occurred while processing the request',
				})
			);
		}
	}

	function* rackingIntegrationItems({ payload }) {
		const { data: body, tableId } = payload;
		const isView = getWebAppSettings(getState())?.IsAclRowLevelAccessEnabled;

		try {
			yield handleToggleLoading({ payload: { status: true } });

			// Fetch racking list
			const {
				isError,
				error,
				data: response,
			} = yield postAPIDataV3({
				...REQUESTS.POST.GET_RACKING_LIST,
				body,
			}).catch((error) => {
				console.error('Error in GET_RACKING_LIST API:', error);
				return { isError: true, error };
			});

			if (isError) {
				throw error || new Error('Failed to get racking list');
			}

			const result = response?.data ?? [];

			const order = result
				.filter((res) => res.success === true && (!res?.data?.hasOwnProperty('isError') || !res?.data?.isError))
				.map((res) => res.data);

			if (order && !order.length) {
				const errorMessage = 'An error occurred while integrating racking, please try again later';
				yield put(triggerNotification({ message: errorMessage }));
				return;
			}

			// Save racking data
			const { isError: isSaveRecorsError, error: saveRecorsError } = yield postAPIDataV3({
				...REQUESTS.POST.SAVE_RACKING,
				body: { order },
			}).catch((error) => {
				console.error('Error in SAVE_RACKING API:', error);
				return { isError: true, error };
			});

			if (isSaveRecorsError) {
				throw saveRecorsError || new Error('Failed to save racking data');
			}

			// Success message
			yield put(
				triggerNotification({
					type: 'success',
					message: 'Racking Added successfully',
				})
			);

			// Refresh grid
			yield put(dynamicGridSagaActions.updateGrid({ tableId, filters: {}, isView }));
			yield handleCloseModal({ payload: { tableIds: [] } });
			yield handleFetchOrderInfo({ payload: { tableId } });
			Events.publish(GRID_EVENTS.CLEAR_SELECTION, { tableId });
		} catch (error) {
			const errorMessage =
				error?.data?.message ||
				error?.message ||
				'An error occurred while integrating racking, please try again later';
			yield put(triggerNotification({ message: errorMessage }));
			console.error('Saga Error:', error);
		} finally {
			yield handleToggleLoading({ payload: { status: false } });
		}
	}

	//update order status
	function* handleGetDefaultOrderStatus() {
		try {
			// Fetch default order statuses
			const response = yield getAPIDataV3({
				service: REQUESTS.GET.GET_ORDER_STATUS.service,
				url: REQUESTS.GET.GET_ORDER_STATUS.url,
			});

			// Check if API response is valid
			if (!response || response?.isError) {
				throw new Error(response?.error?.message || 'An error occurred while fetching default order status.');
			}

			// Extract data safely
			const defaultStores = response?.data?.data || [];

			// Dispatch action to update store
			yield put(slice.updateDefaultOrderStatus({ defaultStores }));
		} catch (error) {
			console.error('Saga Error in handleGetDefaultOrderStatus:', error);
			yield put(
				triggerNotification({
					message: error?.message || 'An error occurred while updating state, please try again later.',
				})
			);
		}
	}

	function* handleUpdateOrderStatus({ payload }) {
		try {
			const { data, tableId } = payload;
			yield handleToggleLoading({ payload: { status: true } });

			// Retrieve selected orders and filters
			const selectedOrders = yield select((state) => dynamicGridSelectors.getTableSelection(state, tableId));
			const ordersSearch = yield select((state) => dynamicGridSelectors.getGridFilters(state, tableId));

			// Prepare request payload
			const requestBody = {
				tableId: Number(tableId),
				statusId: data.statusId,
				isSelectAll: selectedOrders?.isSelectAll || false,
				orderIds: selectedOrders?.selectedRowKeys?.join(',') || '',
				selectAllSearch: JSON.stringify({
					filter: createFiltersFromQueries(ordersSearch?.search || []),
				}),
			};

			// API Call
			const response = yield putAPIDataV3({
				...REQUESTS.PUT.UPDATE_ORDER_STATUS,
				body: requestBody,
			});

			// Check for errors
			if (!response || response?.isError) {
				throw new Error(response?.error?.message || 'Failed to update Order Status, please try again later');
			}

			// Update selected rows and refresh grid
			yield put(
				dynamicGridSagaActions.updateSelectedRows({
					tableId,
					isSelectAll: false,
					selectedRowKeys: [],
				})
			);

			yield put(triggerNotification({ type: 'success', message: 'Order Status updated successfully' }));
			yield put(dynamicGridSagaActions.refreshGridData({ tableId }));
			yield handleCloseModal({ payload: { tableIds: [] } });
			yield handleFetchOrderInfo({ payload: { tableId } });

			// Success Notification
		} catch (error) {
			console.error('Saga Error in handleUpdateOrderStatus:', error);
			yield put(
				triggerNotification({
					message: error?.message || 'An error occurred while updating Order Status, please try again later',
				})
			);
		} finally {
			yield handleToggleLoading({ payload: { status: false } });
		}
	}

	function* handleFetchShipMethods({ payload }) {
		try {
			const { reqData } = payload;

			// Fetch shipping methods
			const response = yield postAPIDataV3({
				...REQUESTS.POST.GET_ORDER_SHIPPING_METHODS,
				body: reqData,
			});

			// Validate response
			if (!response || response.isError) {
				throw new Error(response?.error?.message || 'Failed to fetch shipping methods.');
			}

			// Extract data safely
			const defaultShippingMethods = response?.data?.data || [];

			// Dispatch action to update store
			yield put(slice.updateDefaultShipMethods({ defaultShippingMethods }));
		} catch (error) {
			yield put(
				triggerNotification({
					message:
						error?.message || 'An error occurred while fetching shipping methods, please try again later.',
				})
			);
		}
	}

	function* handleUpdateShipMethods({ payload }) {
		try {
			const { data, tableId } = payload;

			// Toggle loading state ON
			yield handleToggleLoading({ payload: { status: true } });

			// Get selected orders and filters
			const selectedOrders = yield select((state) => dynamicGridSelectors.getTableSelection(state, tableId));
			const ordersSearch = yield select((state) => dynamicGridSelectors.getGridFilters(state, tableId));
			const isView = yield select((state) => getWebAppSettings(state)?.IsAclRowLevelAccessEnabled);

			// Prepare API request payload
			const requestBody = {
				...data,
				isView,
				isSelectAll: selectedOrders.isSelectAll,
				orderIds: selectedOrders?.selectedRowKeys?.join(','),
				selectAllSearch: JSON.stringify({
					filter: createFiltersFromQueries(ordersSearch?.search || []),
				}),
			};

			// API call to update shipping methods
			const response = yield putAPIDataV3({
				...REQUESTS.PUT.BULK_UPDATE_ORDER_SHIPPING_METHODS,
				body: requestBody,
			});

			// Check for errors
			if (!response || response.isError) {
				throw new Error(response?.error?.message || 'An error occurred while updating the shipping method.');
			}
		} catch (error) {
			console.error('Saga Error in handleUpdateShipMethods:', error);
			yield put(
				triggerNotification({
					message:
						error?.message || 'An error occurred while updating shipping method, please try again later.',
				})
			);
		}
	}

	//publish order
	function* handlePublishOrders({ payload }) {
		try {
			const { tableId, data } = payload;
			yield handleToggleLoading({ payload: { status: true } });

			// Get required state values safely
			const isView = yield select((state) => getWebAppSettings(state)?.IsAclRowLevelAccessEnabled);
			const selectedOrders = yield select((state) => dynamicGridSelectors.getTableSelection(state, tableId));
			const ordersSearch = yield select((state) => dynamicGridSelectors.getGridFilters(state, tableId));

			// Prepare request data
			const reqData = {
				tableId: Number(tableId),
				isSelectAll: selectedOrders?.isSelectAll || false,
				orderIds: selectedOrders?.selectedRowKeys?.join(',') || '',
				isErpEnabled: data?.isErpEnabled || false,
				selectAllSearch: JSON.stringify({
					filter: createFiltersFromQueries(ordersSearch?.search || []),
				}),
			};

			// API call to publish orders
			const response = yield postAPIDataV3({
				...REQUESTS.POST.PUBLISH_ORDERS,
				body: { ...reqData, isView },
			});

			// Handle API error response
			if (!response || response.isError) {
				throw new Error(response?.error?.message || 'An error occurred while publishing order.');
			}

			// Proceed if ERP is NOT enabled
			if (!data?.isErpEnabled) {
				const today = moment().format('MM-DD-YYYY');
				const format = response?.data?.data?.format;
				const records = response?.data?.data?.records || [];

				let fileName = `Published Orders-${today}.${format}`;

				// Handle different file formats
				if (format === 'xml') {
					FileDownload(objectToXML(records), fileName);
				} else if (format === 'xls' || format === 'xlsx') {
					exportFromJSON({
						data: { root: { items: records } },
						fileName,
						fields: [],
						exportType: format,
					});
				} else if (format === 'txt') {
					FileDownload(records.map((r) => (r.header ? r.header : '') + '\n').join(''), fileName);
				} else {
					// Default to CSV
					exportFromJSON({
						data: records,
						fileName: `Published Orders-${today}.csv`,
						fields: [],
						exportType: 'csv',
					});
				}

				// Update UI state
				yield put(
					dynamicGridSagaActions.updateSelectedRows({ tableId, isSelectAll: false, selectedRowKeys: [] })
				);
				yield put(dynamicGridSagaActions.updateGrid({ tableId, filters: {}, isView }));
				yield handleCloseModal({ payload: { tableIds: [] } });
				yield handleFetchOrderInfo({ payload: { tableId } });
				yield handleToggleLoading({ payload: { status: false } });
			}
		} catch (error) {
			yield put(
				triggerNotification({
					message: error?.message || 'An error occurred while publishing order, please try again later.',
				})
			);
		}
	}

	//delete order
	function* handleDeleteOrder({ payload }) {
		try {
			const { data, tableId } = payload;
			yield handleToggleLoading({ payload: { status: true } });

			// Get "isView" from Redux safely
			const isView = yield select((state) => getWebAppSettings(state)?.IsAclRowLevelAccessEnabled);

			// API call to delete order
			const response = yield postAPIDataV3({
				...REQUESTS.POST.DELETE_ORDER,
				body: { ...data, isView },
			});

			// Extract potential errors
			const isError = response?.isError;
			const error = response?.error || {};

			// Handle error or warning messages
			if (isError || error?.warning) {
				yield put(
					triggerNotification({
						message: error?.message || 'An error occurred while deleting order, please try again later.',
					})
				);

				// Stop execution if there's no warning
				if (!error?.warning) {
					return;
				}
			}

		} catch (error) {
			yield put(
				triggerNotification({
					message: 'An unexpected error occurred while deleting order, please try again later.',
				})
			);
		}
	}

	//change PO Date
	function* handlePODateUpdation({ payload }) {
		try {
			const { data, tableId } = payload;

			// Fetch necessary state values
			const ordersSearch = yield select((state) => dynamicGridSelectors.getGridFilters(state, tableId));
			const selectedOrders = yield select((state) => dynamicGridSelectors.getTableSelection(state, tableId));
			const isView = getWebAppSettings(getState())?.IsAclRowLevelAccessEnabled;

			// Show loading
			yield handleToggleLoading({ payload: { status: true } });

			// Prepare API payload
			const requestBody = {
				...data,
				isView,
				isSelectAll: selectedOrders.isSelectAll,
				selectAllSearch: JSON.stringify({
					filter: createFiltersFromQueries(ordersSearch.search),
				}),
				tableId: Number(tableId),
			};

			// API call
			const { isError } = yield putAPIDataV3({ ...REQUESTS.PUT.UPDATE_PO_DATE, body: requestBody });

			// Handle error case
			if (isError) {
				throw new Error('An error occurred while updating PO Date, please try again later');
			}
		} catch (error) {
			yield put(
				triggerNotification({
					message: error.message || 'An unexpected error occurred. Please try again later.',
				})
			);
		}
	}

	//open modal
	function* handleOpenModal({ payload }) {
		const { openModalName } = payload;

		yield put(slice.handleOpenModal({ openModalName }));
	}

	//close modal
	function* handleCloseModal({ payload }) {
		const { tableIds } = payload;
		yield put(slice.handleOpenModal({ openModalName: '' }));
		if (tableIds && tableIds.length) {
			yield put(dynamicGridSagaActions.cleanUpGrids({ tableIds: tableIds }));
			yield put(slice.cleanUp());
		}
	}

	//bulk order
	function* fetchGetBulkOrderTypes() {
		try {
			// API call
			const response = yield getAPIDataV3({
				service: REQUESTS.GET.GET_FIELD_LOOKUP.service,
				url: REQUESTS.GET.GET_FIELD_LOOKUP.url,
				queryParams: { ref: 'bulk_order_edit_types' },
			});

			// Extract data safely
			const defaultColumns = response?.data?.data || [];

			// Dispatch update action
			yield put(slice.updateBulkOrderTypes({ defaultColumns }));
		} catch (error) {
			console.error('Failed to fetch bulk order types:', error);

			// Dispatch an empty list or handle the error as needed
			yield put(slice.updateBulkOrderTypes({ defaultColumns: [] }));
		}
	}

	function* handleUpdateBulkEditParams({ payload }) {
		const { bulkParams } = payload;
		yield put(slice.updateBulkEditParams({ bulkParams }));
	}

	function* handleBulkOrderUpdate({ payload }) {
		try {
			const { data, tableId } = payload;
			yield handleToggleLoading({ payload: { status: true } });

			const selectedOrders = yield select((state) => dynamicGridSelectors.getTableSelection(state, tableId));
			const ordersSearch = yield select((state) => dynamicGridSelectors.getGridFilters(state, tableId));
			const isView = getWebAppSettings(getState())?.IsAclRowLevelAccessEnabled;

			// Ensure orderIds is always a string (even if empty)
			const orderIds = selectedOrders?.selectedRowKeys?.length ? selectedOrders.selectedRowKeys.join(',') : '';

			// API Call
			const response = yield postAPIDataV3({
				...REQUESTS.POST.POST_ORDER_BULK_EDIT,
				body: {
					...data,
					isSelectAll: selectedOrders?.isSelectAll || false,
					orderIds,
					selectAllSearch: JSON.stringify({
						filter: createFiltersFromQueries(ordersSearch?.search || []),
					}),
					isView,
				},
			});

			// Handle errors
			if (response?.isError || response?.error?.warning) {
				yield put(
					triggerNotification({
						message: response?.error?.message || 'Unable to update orders, please try again later.',
						type: 'warning',
					})
				);

				// Stop loading only if it's a critical error (not just a warning)
				if (!response?.error?.warning) {
					yield handleToggleLoading({ payload: { status: false } });
					return;
				}
			}
		} catch (error) {
			yield handleToggleLoading({ payload: { status: false } });
			console.error('Bulk Order Update Failed:', error);

			yield put(
				triggerNotification({
					message: 'An error occurred while updating orders. Please try again later.',
					type: 'error',
				})
			);
		}
	}

	// distributeAvailability
	function* handleDistributeAvailability({ payload }) {
		try {
			yield handleToggleLoading({ payload: { status: true } });

			const { tableId } = payload;
			const distributedSKUs = yield select((state) => dynamicGridSelectors.getGridData(state, 36));
			const selectedOrders = yield select((state) => dynamicGridSelectors.getTableSelection(state, tableId));
			const selectedSkus = yield select((state) =>
				dynamicGridSelectors.getTableSelection(state, SELECT_SKUS_TABLE_ID)
			);
			const orders = yield select((state) => dynamicGridSelectors.getGridData(state, tableId));
			const skus = yield select((state) => dynamicGridSelectors.getGridData(state, SELECT_SKUS_TABLE_ID));

			// Ensure we get the full selected order objects, not just row keys
			const filteredOrders = orders.filter(
				(order) =>
					selectedOrders?.selectedRowKeys.includes(order.OrderID) ||
					selectedOrders?.selectedRowKeys.includes(order.OrderDetailID)
			);

			const filters = yield select((state) => dynamicGridSelectors.getGridFilters(state, Number(tableId)));
			const ordersSearch = {
				filter: createFiltersFromQueries(filters?.search || []),
			};

			const skuFilters = yield select((state) =>
				dynamicGridSelectors.getGridFilters(state, SELECT_SKUS_TABLE_ID)
			);
			const skusSearch = {
				filter: createFiltersFromQueries(skuFilters?.search || []),
			};

			// Convert SKU-related lists into CSV strings efficiently
			const skuIdList = distributedSKUs
				.map((sku) => sku?.SKUID)
				.filter(Boolean)
				.join(',');
			const distQtyList = distributedSKUs
				.map((sku) => sku?.DistributionQty)
				.filter(Boolean)
				.join(',');
			const minQtyList = distributedSKUs
				.map((sku) => sku?.DefaultMinOrderQtyPerStore)
				.filter(Boolean)
				.join(',');
			const maxQtyList = distributedSKUs
				.map((sku) => sku?.DefaultMaxOrderQtyPerStore)
				.filter(Boolean)
				.join(',');

			const isView = getWebAppSettings(getState())?.IsAclRowLevelAccessEnabled;

			// API Call
			const response = yield postAPIDataV3({
				...REQUESTS.POST.DISTRIBUTE_AVAILABILITY_ASYNC,
				body: {
					distNumber: skus?.[0]?.DistNumber?.toString() || '',
					tableId: Number(tableId),
					skuIdList,
					isSelectAllSKU: selectedSkus?.isSelectAll || false,
					selectAllSearchSKU: JSON.stringify(skusSearch),
					orderIdList: selectedOrders?.selectedRowKeys?.join(',') || '',
					isSelectAllOrder: selectedOrders?.isSelectAll || false,
					selectAllOrderStore: JSON.stringify(ordersSearch),
					distQtyList,
					minQtyList,
					maxQtyList,
					isView,
				},
			});

			// Handle errors
			if (response?.isError) {
				yield put(
					triggerNotification({
						message: 'Unable to distribute availability, please try again later.',
					})
				);
				return;
			}
		} catch (error) {
			console.error('Error in handleDistributeAvailability:', error);

			yield put(
				triggerNotification({
					message: 'An unexpected error occurred while distributing availability. Please try again.',
					type: 'error',
				})
			);
		}
	}

	function* handleOptimizeShipping({ payload }) {
		try {
			yield handleToggleLoading({ payload: { status: true } });

			const { tableId } = payload;
			const optimizeStores = yield select((state) => dynamicGridSelectors.getGridData(state, 37));
			const optimizeSelectedSkus = yield select((state) => dynamicGridSelectors.getTableSelection(state, 38));
			const selectedOrders = yield select((state) => dynamicGridSelectors.getTableSelection(state, tableId));

			const isView = getWebAppSettings(getState())?.IsAclRowLevelAccessEnabled;

			// Ensure necessary data is available
			if (!optimizeStores?.length || !optimizeSelectedSkus) {
				throw new Error('Missing required data for optimization.');
			}

			// Get filter queries for orders, SKUs, and stores
			const ordersSearch = yield select((state) => dynamicGridSelectors.getGridFilters(state, tableId));
			const skuSearch = yield select((state) => dynamicGridSelectors.getGridFilters(state, 38));
			const storeSearch = yield select((state) => dynamicGridSelectors.getGridFilters(state, 37));

			// Create process status
			const statusObj = {
				OrderBatchID: null,
				StatusTypeID: 4,
				isView,
			};

			const statusResponse = yield postAPIDataV3({
				service: REQUESTS.POST.ADD_PROCESS_STATUS.service,
				url: REQUESTS.POST.ADD_PROCESS_STATUS.url,
				body: statusObj,
			});

			const statusId = statusResponse?.data?.OutputParameters?.StatusID;
			if (!statusId) throw new Error('Failed to retrieve status ID.');

			// Construct optimize shipment payload
			const optimizeObj = {
				skuIdList: optimizeSelectedSkus?.selectedRowKeys?.join(',') || '',
				optimizeShipMethodNumber: optimizeStores?.[0]?.OptimizeShipMethodNumber || '',
				isSelectAllOrders: selectedOrders?.isSelectAll || false,
				selectAllSkusSearch: JSON.stringify({
					filter: createFiltersFromQueries(skuSearch?.search || []),
				}),
				isSelectAllSkus: optimizeSelectedSkus?.isSelectAll || false,
				tableId: Number(tableId),
				statusId,
				isView,
			};

			// API Call
			const response = yield postAPIDataV3({ ...REQUESTS.POST.POST_SHIPMENT_OPTIMIZE, body: optimizeObj });

			if (response?.isError) {
				throw new Error('Optimization failed.');
			}
		} catch (error) {
			console.error('Error in handleOptimizeShipping:', error);

			yield put(
				triggerNotification({
					message: error?.message || 'Unable to optimize, please try again later.',
					type: 'error',
				})
			);
		}
	}

	//toggle loading
	function* handleToggleLoading({ payload }) {
		const { status } = payload;
		yield put(slice.handleToggleLoading({ status }));
	}

	function* handleResetTable({ payload }) {
		const { tableId } = payload;
		yield put(tableColumnsSagaActions.resetTableColumns(tableId));
		yield put(tableColumnsSagaActions.fetchTableColumns(tableId));
	}

	function* handleRefreshTableData({ payload }) {
		const { tableId } = payload;
		yield put(dynamicGridSagaActions.updateGrid({ tableId, filters: { pageNumber: 1 } }));
		yield put(
			dynamicGridSagaActions.updateSelectedRows({
				tableId,
				selectedRowKeys: [],
				isSelectAll: false,
			})
		);
		// yield handleFetchOrderInfo({ payload: { tableId: tableId } });
	}

	function* handleFetchOrderInfo({ payload: { tableId, search } }) {
		try {
			yield handleToggleLoading({ payload: { status: true } });

			// Get search filters if not provided
			const searchQueries =
				search ||
				(yield select((state) => dynamicGridSelectors.getGridFilters(state, Number(tableId))))?.search ||
				[];

			const searchFilter = {
				filter: createFiltersFromQueries(searchQueries, tableId === 30),
			};

			const isView = getWebAppSettings(getState())?.IsAclRowLevelAccessEnabled || Number(tableId) === 30;

			// API Call
			const response = yield postAPIDataV3({
				...REQUESTS.POST.GET_ORDERS_TABLE_SUMMARY,
				body: {
					search: JSON.stringify(searchFilter),
					tableId: Number(tableId),
					isView,
				},
			});

			const data = response?.data?.data;

			// Update store with fetched order info
			yield put(slice.updateOrdersInfo({ info: data?.[0] || {} }));
		} catch (error) {
			if (error?.message !== 'CANCELLED') {
				console.error('Error in handleFetchOrderInfo:', error);

				yield put(
					triggerNotification({
						message: 'Unable to fetch Order Info, please try again later.',
						type: 'error',
					})
				);
			}
		} finally {
			// Ensure loading is stopped in all cases
			yield handleToggleLoading({ payload: { status: false } });
		}
	}

	function* refetchInfo({ payload: { tableId } }) {
		if (_.includes([1, 2, 30, 23, 3, 72], tableId)) {
			let metaData = getGridMetadata(getState(), tableId);
			if (metaData?.dataProviderOptions?.isSubgrid) {
				yield put(sagaActions.getOrdersSummaryInfo({ tableId: metaData?.dataProviderOptions?.parentTable }));
				return;
			}
			yield put(sagaActions.getOrdersSummaryInfo({ tableId }));
		}
	}

	function* handleReceiveEvent({ payload }: TPayload) {
		switch (payload?.type) {
			case 'TABLE_EV':
				if (payload?.eventName === 'distribute_availability') {
					yield handleCloseModal({ payload: { tableIds: [36, 38] } });
					yield handleToggleLoading({ payload: { status: false } });
					if (payload.metaData.type !== 'error') {
						yield refetchInfo({ payload: { tableId: payload?.metaData?.tableId } });

						yield put(
							dynamicGridSagaActions.refreshGridData({
								tableId: payload?.metaData?.tableId,
							})
						);
						yield put(
							dynamicGridSagaActions.updateSelectedRows({
								tableId: payload?.metaData?.tableId,
								isSelectAll: false,
								selectedRowKeys: [],
							})
						);
					}
				}
				if (payload?.eventName === 'clone_orders') {
					yield handleCloseModal({ payload: { tableIds: [31] } });
					yield handleToggleLoading({ payload: { status: false } });

					if (payload.metaData.type !== 'error') {
						yield put(slice.updateCloneSelectedParameters({}));
						yield put(
							dynamicGridSagaActions.refreshGridData({
								tableId: payload?.metaData?.tableId,
							})
						);
						yield handleFetchOrderInfo({ payload: { tableId: payload?.metaData?.tableId } });
						yield put(
							dynamicGridSagaActions.updateSelectedRows({
								tableId: payload?.metaData?.tableId,
								isSelectAll: false,
								selectedRowKeys: [],
							})
						);
					}
				}
				if (payload?.eventName === 'optimize_shipmethod') {
					yield handleCloseModal({ payload: { tableIds: [37, 38] } });
					yield handleToggleLoading({ payload: { status: false } });
					if (payload.metaData.type !== 'error') {
						yield refetchInfo({ payload: { tableId: payload?.metaData?.tableId } });
						yield handleFetchOrderInfo({ payload: { tableId: payload?.metaData?.tableId } });

						yield put(
							dynamicGridSagaActions.refreshGridData({
								tableId: payload?.metaData?.tableId,
							})
						);
						yield put(
							dynamicGridSagaActions.updateSelectedRows({
								tableId: payload?.metaData?.tableId,
								isSelectAll: false,
								selectedRowKeys: [],
							})
						);
					}
				}
				if (payload?.eventName === 'split_orders') {
					yield handleCloseModal({ payload: { tableIds: [35] } });
					yield handleToggleLoading({ payload: { status: false } });

					if (payload.metaData.type !== 'error') {
						yield refetchInfo({ payload: { tableId: payload?.metaData?.tableId } });

						yield put(
							dynamicGridSagaActions.refreshGridData({
								tableId: payload?.metaData?.tableId,
							})
						);
						yield put(
							dynamicGridSagaActions.updateSelectedRows({
								tableId: payload?.metaData?.tableId,
								isSelectAll: false,
								selectedRowKeys: [],
							})
						);
					}
				}
				if (payload?.eventName === 'bulk_update') {
					yield handleCloseModal({ payload: { tableIds: [] } });
					yield handleToggleLoading({ payload: { status: false } });

					if (payload.metaData.type !== 'error') {
						yield put(
							dynamicGridSagaActions.refreshGridData({
								tableId: payload?.metaData?.tableId,
							})
						);

						yield refetchInfo({ payload: { tableId: payload?.metaData?.tableId } });
						yield put(
							dynamicGridSagaActions.updateSelectedRows({
								tableId: payload?.metaData?.tableId,
								isSelectAll: false,
								selectedRowKeys: [],
							})
						);
					}
				}

				if (payload?.eventName === 'update_podate') {
					yield handleCloseModal({ payload: { tableIds: [] } });
					yield handleToggleLoading({ payload: { status: false } });

					if (payload.metaData.type !== 'error') {
						yield put(
							dynamicGridSagaActions.refreshGridData({
								tableId: payload?.metaData?.tableId,
							})
						);
						yield put(
							dynamicGridSagaActions.updateSelectedRows({
								tableId: payload?.metaData?.tableId,
								selectedRowKeys: [],
								isSelectAll: false,
							})
						);

						yield handleFetchOrderInfo({ payload: { tableId: payload?.metaData?.tableId } });
					}
				}

				if (payload?.eventName === 'delete_orders') {
					yield handleCloseModal({ payload: { tableIds: [] } });
					yield handleToggleLoading({ payload: { status: false } });

					if (payload.metaData.type !== 'error') {
						yield put(
							dynamicGridSagaActions.refreshGridData({
								tableId: payload?.metaData?.tableId,
							})
						);
						yield put(
							dynamicGridSagaActions.updateSelectedRows({
								tableId: payload?.metaData?.tableId,
								selectedRowKeys: [],
								isSelectAll: false,
							})
						);
						yield handleFetchOrderInfo({ payload: { tableId: payload?.metaData?.tableId } });
					}
				}

				if (payload?.eventName === 'update_shipmethods') {
					yield handleCloseModal({ payload: { tableIds: [] } });
					yield handleToggleLoading({ payload: { status: false } });

					if (payload.metaData.type !== 'error') {
						yield put(
							dynamicGridSagaActions.refreshGridData({
								tableId: payload?.metaData?.tableId,
							})
						);
						yield handleFetchOrderInfo({ payload: { tableId: payload?.metaData?.tableId } });
						yield put(
							dynamicGridSagaActions.updateSelectedRows({
								tableId: payload?.metaData?.tableId,
								isSelectAll: false,
								selectedRowKeys: [],
							})
						);
					}
				}

				if (payload?.eventName === 'publish_orders') {
					yield handleCloseModal({ payload: { tableIds: [] } });
					yield handleToggleLoading({ payload: { status: false } });
					if (payload.metaData?.type !== 'error') {
						yield handleFetchOrderInfo({ payload: { tableId: payload?.metaData?.tableId } });
						yield put(
							dynamicGridSagaActions.refreshGridData({
								tableId: payload?.metaData?.tableId,
							})
						);
					}
				}
				break;
		}
	}

	async function getShipMethodOptimizeNumber({ payload }) {
		const dispatch = getDispatch();

		try {
			const response = await getAPIDataV3({
				service: REQUESTS.GET.GET_SHIPMENT_OPTIMIZE.service,
				url: REQUESTS.GET.GET_SHIPMENT_OPTIMIZE.url,
				pathParams: { userName: payload.userName },
			});

			const optimizeShipMethodNumber = response?.data?.OptimizeShipMethodNumber;

			if (optimizeShipMethodNumber !== undefined) {
				dispatch(slice.updateOptimizeNumber({ optimizeShipMethodNumber }));
			} else {
				console.warn('Optimize Ship Method Number not found in response.');
			}
		} catch (error) {
			console.error('Error fetching Ship Method Optimize Number:', error);

			dispatch(
				triggerNotification({
					message: 'Unable to fetch shipment optimization number, please try again later.',
					type: 'error',
				})
			);
		}
	}

	async function getOptimizeAggregateData({ payload }) {
		const dispatch = getDispatch();

		// Show loader before request starts
		dispatch(
			toggleLoader({
				component: 'optimize-aggregate-data',
				isLoading: true,
			})
		);

		try {
			const userName = sessionStorage.getItem('userName') || 'None';
			const isView = getWebAppSettings(getState())?.IsAclRowLevelAccessEnabled;

			const response = await postAPIDataV3({
				...REQUESTS.POST.GET_SHIPMENT_STORES,
				pathParams: { userName },
				body: {
					fieldGroups: {
						OptimizeShipMethodNumberInput: payload.optimizeShipMethodNumber,
						IsAggregationEnabled: true,
					},
					orderIds: payload.orderIds,
					isSelectAll: payload.isOrderSelectAll,
					selectAllSearch: payload.ordersSelectAllSearch,
					tableId: payload.tableId,
					isView,
				},
			});

			const aggregateData = response?.data?.data?.[0] || {};
			const optimizeAggregateInfo = {
				TotalCurrentQty: aggregateData.TotalCurrentQty ?? 0,
				TotalDesiredQty: aggregateData.TotalDesiredQty ?? 0,
			};

			dispatch(slice.updateOptimizeAggregateData({ optimizeAggregateInfo }));
		} catch (error) {
			console.error('Error fetching Optimize Aggregate Data:', error);

			dispatch(
				triggerNotification({
					message: 'Unable to fetch optimized aggregate data, please try again later.',
					type: 'error',
				})
			);
		}
	}

	return [
		yield takeLatest(dynamicGridSagaActions.updateRowData, updateRowData),
		yield takeLatest(sagaActions.getShipMethodOptimizeNumber, getShipMethodOptimizeNumber),
		yield takeLatest(sagaActions.getOptimizeAggregateData, getOptimizeAggregateData),
		yield takeLatest(sagaActions.updateCloneSelectedParameters, handleUpdateCloneSelectedParameters),
		yield takeLatest(sagaActions.getCloneDefaultColumnTypes, handleGetCloneDefaultColumnTypes),
		yield takeLatest(sagaActions.cloneOrders, handleCloneOrders),
		yield takeLatest(sagaActions.updateSplitSelectedParameters, handleUpdateSplitSelectedParameters),
		yield takeLatest(sagaActions.getSplitDefaultColumnTypes, handleGetSplitDefaultColumnTypes),
		yield takeLatest(sagaActions.splitOrders, handleSplitOrders),
		yield takeLatest(sagaActions.lockUnlockRecords, lockUnlockRecords),
		yield takeLatest(sagaActions.getDefaultOrderStatus, handleGetDefaultOrderStatus),
		yield takeLatest(sagaActions.updateOrderStatus, handleUpdateOrderStatus),
		yield takeLatest(sagaActions.getShipMethods, handleFetchShipMethods),
		yield takeLatest(sagaActions.updateShipMethods, handleUpdateShipMethods),
		yield takeLatest(sagaActions.publishOrders, handlePublishOrders),
		yield takeLatest(sagaActions.deleteOrder, handleDeleteOrder),
		yield takeLatest(sagaActions.updatePODate, handlePODateUpdation),
		yield takeLatest(sagaActions.toggleModalOpen, handleOpenModal),
		yield takeLatest(sagaActions.toggleModalClose, handleCloseModal),
		yield takeLatest(sagaActions.getBulkOrderTypes, fetchGetBulkOrderTypes),
		yield takeLatest(sagaActions.distrbuteAvailability, handleDistributeAvailability),
		yield takeLatest(sagaActions.optimizeShipping, handleOptimizeShipping),
		yield takeLatest(sagaActions.toggleLoading, handleToggleLoading),
		yield takeLatest(sagaActions.resetTable, handleResetTable),
		yield takeLatest(sagaActions.refreshTableData, handleRefreshTableData),
		yield takeLatest(sagaActions.updateBulkEditParams, handleUpdateBulkEditParams),
		yield takeLatest(sagaActions.updateBulkOrders, handleBulkOrderUpdate),
		yield takeLatest(sagaActions.getOrdersSummaryInfo, handleFetchOrderInfo),
		yield takeLatest(sagaActions.rackingIntegrationItems, rackingIntegrationItems),
		yield takeLatest(dynamicGridSagaActions.handleRowUpdateSuccess, refetchInfo),
		yield takeLatest(onReceiveEvent, handleReceiveEvent),
	];
}
